module.exports = __webpack_public_path__ + "static/lif-response-1-e85a7dbfe1f06ed43238c93e952cdc01.mp4";